import React from 'react'
import { Input, Select, DatePicker } from 'antd'
import { SearchOutlined } from '@ant-design/icons'

const { Option } = Select
const { RangePicker } = DatePicker

const DischargeFilters = ({ filterValues, filterState }) => {
  const {
    searchText,
    setSearchText,
    departmentFilter,
    setDepartmentFilter,
    statusFilter,
    setStatusFilter,
    dateRange,
    setDateRange
  } = filterState

  const { departments, statuses } = filterValues

  return (
    <div style={{ marginBottom: '16px', display: 'flex', flexWrap: 'wrap', gap: '16px', alignItems: 'center' }}>
      <Input
        placeholder='Search by patient name, ID, or diagnosis'
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        style={{ width: 300 }}
        prefix={<SearchOutlined />}
        allowClear
      />

      <Select
        placeholder='Department'
        style={{ width: 200 }}
        value={departmentFilter}
        onChange={(value) => setDepartmentFilter(value)}
      >
        <Option value='all'>All Departments</Option>
        {departments.map((dept) => (
          <Option key={dept} value={dept}>
            {dept}
          </Option>
        ))}
      </Select>

      <Select
        placeholder='Status'
        style={{ width: 150 }}
        value={statusFilter}
        onChange={(value) => setStatusFilter(value)}
      >
        <Option value='all'>All Statuses</Option>
        {statuses.map((status) => (
          <Option key={status} value={status}>
            {status}
          </Option>
        ))}
      </Select>

      <RangePicker
        onChange={(dates) => setDateRange(dates)}
        value={dateRange}
        style={{ width: 280 }}
        placeholder={['Discharge Date From', 'Discharge Date To']}
      />
    </div>
  )
}

export default DischargeFilters
